import React from 'react';
import I18n from 'lib/i18n/i18n';
import { imageUrl } from 'helpers/ApplicationHelper';
import UserActions from 'lib/userActions';

// FIXME: move the component to Clarity once we have data how often users click on it
// and make all Card component clickable or only links within the text

class Services extends React.Component {
    constructor(props) {
        super(props);
        this.itemId = props.itemId;
        this.version = props.version;
        this.services = [
            {
                title: I18n.getString('preAuctionServices::cleaning::title'),
                img: imageUrl('listing/service-cleaning.jpg'),
                description: I18n.getString('preAuctionServices::cleaning::description'),
                cost: 25
            },
            {
                title: I18n.getString('preAuctionServices::photographing::title'),
                img: imageUrl('listing/service-photographing.jpg'),
                description: I18n.getString('preAuctionServices::photographing::description'),
                cost: 120
            },
            {
                title: I18n.getString('preAuctionServices::grading::title'),
                img: imageUrl('listing/service-grading.jpg'),
                description: I18n.getString('preAuctionServices::grading::description'),
                cost: 90
            }
        ];
    }

    componentDidMount() {
        UserActions.listingPage('«Pre-Auction Services» presented', this.itemId, this.version);
    }

    click = (title) => {
        UserActions.listingPage(`User clicked on one of Pre auction services: «${ title }»`, this.itemId, this.version);
    }

    render() {
        return <div className='listing-content services pre-auction-services'>
            <div className='pre-auction-services-about'>
                <h3 className='pre-auction-services-title'>{ I18n.getString('preAuctionServices::title') }</h3>
                <p className='pre-auction-services-description'>{ I18n.getString('preAuctionServices::description') }</p>
            </div>
            <div className="pre-auction-services-list-wrapper">
                <ul className='pre-auction-services-list'>
                    {
                        this.services.map((service, idx) => {
                            return <li onClick={ () => this.click(service.title) } key={idx} className='card pre-auction-service'>
                                <img className='card-image'
                                     src={ service.img }
                                     alt={ service.title }/>
                                    <div className='card-description-wrapper'>
                                         <h1 className='card-title'>{ service.title }</h1>
                                         <p className='card-description'>{ service.description }</p>
                                         <span className='card-cost'><s>${ service.cost }</s>Free</span>
                                     </div>
                            </li>
                        })
                    }
                </ul>
            </div>
        </div>
    }
}

export default Services;